import React from 'react';
import { Box } from '@wix/design-system';
import { getLogoUrl } from '../../../DocParts/Logo/getLogoUrl';
export const Logo = ({ logo, onImageReady = () => { } }) => {
    const hasLogo = !!(logo && logo.match(/(?:[^/]+)$/));
    React.useEffect(() => {
        if (!hasLogo) {
            onImageReady();
        }
    }, [hasLogo]);
    if (!hasLogo) {
        return React.createElement(Box, null);
    }
    // TODO: revise width
    return (React.createElement(Box, null, logo && (React.createElement("img", { style: {
            alignSelf: 'center',
            height: 'auto',
            maxHeight: '70px',
            maxWidth: '100%',
            position: 'relative',
            width: 'auto',
        }, alt: "", decoding: "sync", src: getLogoUrl(logo, { maxWidth: 622, maxHeight: 200 }), onError: ({ target: image }) => {
            if (image instanceof HTMLImageElement && image.parentElement) {
                image.parentElement.style.display = 'none';
            }
            onImageReady();
        }, onLoad: onImageReady }))));
};
//# sourceMappingURL=Logo.js.map